'use client';

/**
 * Resolves a destination's lucide icon name (a string in
 * lib/uiPreferences DESTINATIONS) to the actual icon component. Keeps
 * the preferences module React-free while letting nav + hub render
 * real icons. Falls back to a neutral dot if a name is unmapped.
 */

import {
  Home, Settings, Dumbbell, ListChecks, LayoutGrid, PlusSquare, Wrench,
  Calculator, Wind, Crosshair, Zap, Plane, HeartPulse, BarChart3, Heart,
  History, ClipboardCheck, Utensils, Map, Shield, Trophy, Flame, Menu, Circle,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  Home, Settings, Dumbbell, ListChecks, LayoutGrid, PlusSquare, Wrench,
  Calculator, Wind, Crosshair, Zap, Plane, HeartPulse, BarChart3, Heart,
  History, ClipboardCheck, Utensils, Map, Shield, Trophy, Flame, Menu,
};

export default function DestinationIcon({ name, className }: { name: string; className?: string }) {
  const Icon = ICONS[name] ?? Circle;
  return <Icon className={className} aria-hidden />;
}
